export default __webpack_public_path__ + "static/media/UltrasonicImg.232c0d52.jpg";